<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:54:49
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-06 15:42:14
-->
<template>
  <div>
    <div class="top">
      <el-button  v-if="codeData.indexOf('138') != -1" class="btn" @click="addAdminFn" type="primary"
        >新媒体统计</el-button
      >
      <div class="search">
        <!-- <div class="select-org">
            <TreeSelect v-if="listData.length > 0"  @selectpart="selectpart" :resData="listData"></TreeSelect>
        </div> -->
        <a-select
          showArrow
          v-model:value="stations"
          style="width: 200px; margin-right: 20px"
          placeholder="站点授权筛选"
        >
          <a-select-option
            :key="index"
            v-for="(item, index) in siteList"
            :value="item.id"
            >{{ item.name }}</a-select-option
          >
        </a-select>
        <a-select
          showArrow
          v-model:value="roleIds"
          style="width: 200px; margin-right: 20px"
          placeholder="按角色筛选"
        >
          <a-select-option
            :key="index"
            v-for="(item, index) in rolesData"
            :value="item.id"
            >{{ item.roleName }}</a-select-option
          >
        </a-select>
        <el-button @click="search" type="primary">查询</el-button>
      </div>
    </div>
    <coententTable
      :loading="loading"
      :y="height"
      @handleSizeChange="handleSizeChange"
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :pagination="pagination"
      :dataSource="dataSource"
    ></coententTable>
    <el-dialog
      title="新媒体统计"
      :visible.sync="isShow"
      width="820px"
      class="column-box"
      top="12%"
    >
      <div class="item-one">
         <div class="zhang-hao">
             <div>
                 <div class="zhang-hao-name">账号总数</div>
                <div class="zhang-hao-name">{{contData.accountNumber}}个</div>
             </div>
             <img class="zhang-hao-img" src="@/assets/images/md-people.png" />
         </div>
         <div class="wei-xin">
            <div style="display:flex;">
                 <div class="wei-xin-box"><img class="wei-xin-img" src="@/assets/images/wei-xin.png"></div>
                <div class="wei-xin-txt">
                    <div class="wei-xin-name">微信公众号</div>
                    <div><span class="wei-xin-num">{{contData.wxCount || 0}}</span> 个</div>
                </div>
            </div>
            <div class="dir"></div>
         </div>
         <div class="wei-xin">
            <div  style="display:flex">
                <div style="background:#FFF8F1" class="wei-xin-box"><img class="wei-xin-img" src="@/assets/images/wei-bo.png"></div>
                <div class="wei-xin-txt">
                    <div class="wei-xin-name">微博账号</div>
                    <div><span class="wei-xin-num">{{contData.wbCount || 0}}</span> 个</div>
                </div>
            </div>
            <div class="dir"></div>
         </div>
          <div class="wei-xin">
            <div  style="display:flex">
                <div style="background:#FCF2F2" class="wei-xin-box"><img class="wei-xin-img" src="@/assets/images/tou-tiao.png"></div>
                <div class="wei-xin-txt">
                    <div class="wei-xin-name">头条账号</div>
                    <div><span  class="wei-xin-num">{{contData.contData || 0}}</span> 个</div>
                </div>
            </div>
            <div class="dir"></div>
         </div>
          <div class="wei-xin">
            <div style="display:flex;">
                <div style="background:#F3EDFD" class="wei-xin-box"><img class="wei-xin-img" src="@/assets/images/dou-ying.png"></div>
                <div class="wei-xin-txt">
                    <div class="wei-xin-name">抖音账号</div>
                    <div><span class="wei-xin-num">{{contData.douyiCount || 0}}</span> 个</div>
                </div>
            </div>
         </div>
      </div>
      <div  class="item-one">
         <div style="background:#E9A710" class="zhang-hao">
             <div>
                 <div class="zhang-hao-name">发布总数</div>
                <div class="zhang-hao-name">{{contData.count}} 篇</div>
             </div>
             <img class="zhang-hao-img" src="@/assets/images/fa-bu.png" />
         </div>
         <div class="fa-bu-box">
            <div class="wei-xin fu-bu-one">
              <div class="wei-xin-txt">
                  <div class="wei-xin-name">昨日发布</div>
                  <div><span class="wei-xin-num" style="color:rgba(232, 55, 46, 1)">{{contData.toDaysCount}}</span> 篇</div>
              </div>
              <div class="dir"></div>
         </div>
         <div class="wei-xin fu-bu-one">
            <div class="wei-xin-txt">
                <div class="wei-xin-name">近一周发布</div>
                <div><span class="wei-xin-num" style="color:rgba(232, 55, 46, 1)">{{contData.weekCount}}</span> 篇</div>
            </div>
            <div class="dir"></div>
         </div>
          <div class="wei-xin fu-bu-one">
            <div class="wei-xin-txt">
                <div class="wei-xin-name">近一月发布</div>
                <div><span class="wei-xin-num" style="color:rgba(232, 55, 46, 1)">{{contData.monthCount}}</span> 篇</div>
            </div>
            <div class="dir"></div>
         </div>
          <div class="wei-xin fu-bu-one">
            <div class="wei-xin-txt">
                <div class="wei-xin-name">近一年发布</div>
                <div><span class="wei-xin-num" style="color:rgba(232, 55, 46, 1)">{{contData.yearCount}}</span> 篇</div>
            </div>
         </div>
         </div>
      </div>
      <div  class="item-one">
         <div style="background:#00D7B6" class="zhang-hao">
             <div>
                 <div class="zhang-hao-name">留言总数</div>
                <div class="zhang-hao-name">{{contData.commentCount}}个</div>
             </div>
             <img class="zhang-hao-img" src="@/assets/images/liu-yan.png" />
         </div>
         <div class="fa-bu-box">
         <div class="wei-xin fu-bu-one">
            <div class="wei-xin-txt">
                <div class="wei-xin-name">近一周留言</div>
                <div><span class="wei-xin-num" style="color:rgba(232, 55, 46, 1)">{{contData.weekCountNumber}}</span> 条</div>
            </div>
            <div class="dir"></div>
         </div>
          <div class="wei-xin fu-bu-one">
            <div class="wei-xin-txt">
                <div class="wei-xin-name">近一月留言</div>
                <div><span class="wei-xin-num" style="color:rgba(232, 55, 46, 1)">{{contData.monthCountNumber}}</span> 条</div>
            </div>
            <div class="dir"></div>
         </div>
         <div class="wei-xin fu-bu-one">
              <div class="wei-xin-txt">
                  <div class="wei-xin-name">近三月留言</div>
                  <div><span class="wei-xin-num" style="color:rgba(232, 55, 46, 1)">{{contData.tmonthCountNumber}}</span> 条</div>
              </div>
              <div class="dir"></div>
         </div>
          <div class="wei-xin fu-bu-one">
            <div class="wei-xin-txt">
                <div class="wei-xin-name">近一年留言</div>
                <div><span class="wei-xin-num" style="color:rgba(232, 55, 46, 1)">{{contData.yearCountNumber}}</span> 条</div>
            </div>
         </div>
         </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShow = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import { selectPage, countMedia } from "./new_media_monitoring";
export default {
  data() {
    return {
      height: 0,
      selectName: "用户姓名",
      selectValue: "1",
      value: "",
      stations: 1,
      roleIds: 1,
      siteList: [
        {
          id: 1,
          name: "微信公众号",
        },
        {
          id: 2,
          name: "微博",
        },
        {
          id: 3,
          name: "今日头条",
        },
        {
          id: 4,
          name: "抖音",
        },
      ],
      rolesData: [
        {
          id: 1,
          roleName: "近7日发文数从高到低",
        },
        {
          id: 2,
          roleName: "近7日发文数从低到高",
        },
        {
          id: 3,
          roleName: "总发文数从高到低",
        },
        {
          id: 4,
          roleName: "总发文数从低到高",
        },
        {
          id: 5,
          roleName: "总阅读数从高到低",
        },
        {
          id: 6,
          roleName: "总阅读数从低到高",
        },
      ],
      columns: [
        {
          title: "所属平台",
          dataIndex: "typeName",
          width: 300,
          ellipsis: true,
        },
        {
          title: "新媒体名称",
          dataIndex: "name",
          ellipsis: true,
          customCell: column => {
                            return {
                            style: {
                                'min-width': "320px",
                                'max-width': "560px",
                            }
                        };
                        },
                        customHeaderCell: column => {
                        return {
                            style: {
                                'min-width': "320px",
                                'max-width': "560px",
                            }
                        };
                        }
        },
        {
          title: "账号主体",
          dataIndex: "number",
          width: 200,
          ellipsis: true,
        },
        {
          title: "授权人",
          dataIndex: "grantName",
           width: 120,
          ellipsis: true,
        },
        {
          title: "近7日发文数",
          dataIndex: "num",
           width: 120,
          ellipsis: true,
        },
        {
          title: "总发文数",
          dataIndex: "countNum",
          width: 120,
          ellipsis: true,
        },
        {
          title: "总阅读数",
          dataIndex: "readNumber",
          width: 120,
          ellipsis: true,
        },
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
      },
      dataSource: [],
      loading: false,
      isShow: false,
      contData:{},
      codeData:[],
    };
  },
  components: {
    coententTable,
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 419;
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    window.onresize = () => {
      return (() => {
        this.height = document.documentElement.clientHeight - 419;
      })();
    };
    this.getList();
  },
  methods: {
    addAdminFn() {
      this.isShow = true;
      countMedia({}).then((res) => {
         if(res.code == 0){
            this.contData = res.data;
         }
      });
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.current = 1;
      this.getList();
    },
    search() {
      this.pagination.current = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      selectPage({
        type: this.stations,
        typeOrder: this.roleIds,
        current: this.pagination.current,
        size: this.pagination.pageSize,
      }).then((res) => {
        if (res.code == 0) {
          this.dataSource = res.data.records;
          this.pagination.current = res.data.current;
          this.pagination.total = res.data.total;
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #f4f4f6 2px;
  display: flex;
  justify-content: space-between;
  .search {
    display: flex;
    width: 500px;
  }
  /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-select .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
      /deep/ .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
      }
      /deep/ .el-select__tags {
        flex-wrap: nowrap;
      }
  .add-img {
    margin-top: -2px;
    margin-right: 3px;
  }
}
.icon-md-poll:before {
  color: #fff;
  margin-right: 5px;
}
.btn {
  display: flex;
  align-items: center;
}
/deep/ .el-dialog__title {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  font-weight: 600;
  color: #000;
}
.wei-xin-box{
  width: 50px;
  height: 50px;
  line-height: 20px;
  background-color: rgba(245, 255, 236, 1);
  text-align: center;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wei-xin-img{
  width: 30px;
  height: 30px;
}
.zhang-hao{
  width: 120px;
  height: 74px;
  background-color: rgba(42, 131, 221, 1);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-right: 16px;
}
.zhang-hao-img{
   width: 50px;
    /* height: 50px; */
    position: absolute;
    left: 0;
    /* bottom: 58px; */
    /* bottom: 72px; */
    bottom: 0;
}
.zhang-hao-name{
  width: 56px;
  height: 18px;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  text-align: left;
  font-family: Roboto-bold;
  text-align: center;
  margin-bottom: 3px;
  font-weight: 600;
}
.wei-xin{
  display: flex;
  justify-content: space-between;
  flex: 1;
  align-items: center;
}
.wei-xin-name{
  color: rgba(96, 98, 102, 1);
  font-size: 14px;
  text-align: left;
  font-family: Roboto-bold;
  font-weight: 600;
}
.wei-xin-num{
  color: rgba(48, 49, 51, 1);
  font-size: 20px;
  text-align: left;
  font-family: Arial-bold;
  font-weight: 600;
}
.item-one{
  display: flex;
  border: 1px solid rgba(42, 131, 221, 1);
  align-items: center;
  border-radius: 4px 0px 0px 4px;
  margin-bottom: 20px;
}
.item-one:last-child{
  margin-bottom: 0px;
}
.wei-xin-txt{
  margin-left: 10px;
}
.dir{
  width: 1px;
  height: 30px;
  border: 1px solid rgba(220, 223, 230, 1);
  margin-right: 16px;
}
.fa-bu-box{
  display: flex;
  justify-content: space-between;
  flex: 1;
}
.fu-bu-one{
  flex: 1;
  display: flex;
  justify-content: space-between;
  .wei-xin-txt{
    text-align: center;
    margin:  0 auto;
    .wei-xin-num{
      text-align: center;
    }
  }
}
.el-button--primary {
  background: #176de6;
}
@media screen and (max-width: 720px) {
  .item-one{
    width: 800px !important;
  }
}
</style>